import client from '../utils/client';
import { appLogsUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const appLogService = {
  appLogsList,
  appLogLevels,
  appLogShow,
};

function appLogsList(filters) {
  const params = new URLSearchParams();
  params.set('page', filters.page || 1);
  params.set('per_page', filters.perPage || 20);
  if (filters.level) params.set('level', filters.level);
  if (filters.channel) params.set('channel', filters.channel);
  if (filters.source) params.set('source', filters.source);
  if (filters.search) params.set('search', filters.search);
  if (filters.startDate) params.set('start_date', filters.startDate);
  if (filters.endDate) params.set('end_date', filters.endDate);

  return client.get(appLogsUrl + '?' + params.toString())
    .then(response => response)
    .catch(handleResponse);
}

function appLogLevels() {
  return client.get(appLogsUrl + '/levels')
    .then(response => response)
    .catch(handleResponse);
}

function appLogShow(id) {
  return client.get(appLogsUrl + '/' + id + '/show')
    .then(response => response)
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response;
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}
